module.exports = __webpack_public_path__ + "static/media/ear.8c1e370a.svg";